import React from 'react';
import ElevatorSlider from '../component/ElevatorSlider';

const HeroSection = () => {
  return (
    <div className="relative z-0 overflow-visible">
      <ElevatorSlider />
    </div>
  );
};

export default HeroSection;
